import { Link, useLocation } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  usePageMeta({
    title: '页面不存在 - 河北彩花影视大全',
    description: '抱歉，您访问的页面不存在，可返回首页或浏览河北彩花影视作品与明星资料。',
  });

  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
      <p className="font-heading text-7xl font-black text-primary-100 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        抱歉，您访问的页面不存在
      </h1>
      <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
        页面可能已被移动、删除，或者链接地址输入有误。
      </p>
      <p className="mt-2 break-all rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
        {location.pathname}
      </p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
        >
          <i className="ri-film-line"></i>
          浏览影视作品
        </Link>
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-foreground-500">
        <Link to="/stars" className="transition-colors hover:text-primary-600">明星资料</Link>
        <Link to="/news" className="transition-colors hover:text-primary-600">动态资讯</Link>
        <Link to="/about" className="transition-colors hover:text-primary-600">关于我们</Link>
      </div>
    </div>
  );
}